<template>
  <cos-table
    serial
    :columns="columns"
    @fetch="fetch"
    v-model:search="queryForm"
    ref="tableRef"
    tableId="DcCosRegionList"
  >
    <template #search>
      <a-form :model="queryForm">
        <dc-form-item name="name" label="国家">
          <a-input v-model:value="queryForm.countryCnName" allowClear placeholder="请输入" />
        </dc-form-item>
        <dc-form-item name="name" label="国家二字码">
          <a-input v-model:value="queryForm.countryCharCode" allowClear placeholder="请输入" />
        </dc-form-item>
      </a-form>
    </template>
    <template #bodyCell="{ column, record }">
      <template v-if="column.dataIndex === 'action'">
        <more-button>
          <a-button type="link" @click="addEdit(record)" v-permission="'base_adminregion_edit_btn'">编辑</a-button>
          <a-button type="link" @click="deleteRow(record)" v-permission="'base_adminregion_delete_btn'">删除</a-button>
        </more-button>
      </template>
    </template>
    <template #button>
      <a-button type="primary" @click="addEdit()" v-permission="'base_adminregion_add_btn'">新增</a-button>
    </template>
  </cos-table>
  <editModal ref="editModalRef" @success="success" />
</template>
<script lang="ts">
import editModal from './editModal.vue'
import Modal from '@/hooks/modalType'
import { reactive, ref } from 'vue'
import { adminAreaFindByPage, adminAreaDelete } from '@/api/overseasSales/administrativeRegion'
import { adminAreaSaveParams, adminAreaFindByPageParams } from '@/typings/api/overseasSales'
import { DcMessage } from '@dc-platform/dc-components'

export default { name: 'list' }
</script>
<script setup lang="ts">
const editModalRef = ref()
const tableRef = ref()
const queryForm = reactive<adminAreaFindByPageParams>({})

// onMounted(() => {
// })
// 获取列表
const fetch = (params: adminAreaFindByPageParams, callBack: (res: any) => void) => {
  adminAreaFindByPage({
    ...params,
    level: 1
  }).then((res) => {
    callBack(res)
  })
}
const success = () => {
  tableRef.value.fetch()
}
const columns = ref([
  { title: '国家二字码', dataIndex: 'countryCharCode' },
  { title: '国家中文名', dataIndex: 'countryCnName' },
  { title: '国家英文名', dataIndex: 'countryEnName' },
  { title: '创建人', dataIndex: 'operatorName' },
  { title: '创建时间', dataIndex: 'operationTime' },
  {
    title: '操作',
    dataIndex: 'action',
    fixed: 'right'
  }
])
const addEdit = (_row?: adminAreaSaveParams) => {
  editModalRef.value?.toggle(_row)
}
const deleteRow = (row: adminAreaSaveParams) => {
  Modal.delete({
    name: row.countryCharCode,
    onOk() {
      adminAreaDelete({ id: row.id }).then(() => {
        DcMessage.success('删除成功')
        tableRef.value?.delFetch()
      })
    }
  })
}
</script>

<style scoped></style>
